
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

// 引入完整ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import storage from "@/utils/storage";

import router from './router'
import store from './store'

Vue.prototype.$storage = storage
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueRouter)

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})
